<template>
  <div class="anchor-contact" :style="{width: vip!==undefined?'6rem':'6.9rem', height: vip!==undefined?'4.7rem':'5rem'}">
    <div v-if="vip!==undefined" style="height: 100%">
      <div class="align direction vip-links" style="height: 100%" v-if="links.length">
        <div class="contact-data align jus direction">
          <div v-for="(item, index) in this.$_.chunk(links, 5)[0]" :key="index" class="align item-contact">
            <div class="contact-name">{{item.label}}</div>
            <div class="contact-value">{{item.value}}</div>
          </div>
        </div>
        <div class="contact-tips">*数据来自达人公开信息及用户授权提供</div>
      </div>
      <div v-if="!links.length" class="none-links align direction">
        <div class="none-links-tips">该达人暂未授权公开联系方式</div>
        <div class="none-links-tips">若您急需请联系壁虎看看运营方获取</div>
        <div class="abi">
          <img src="https://s6.bihukankan.com/bihu_wx_code/0506abi.png" alt />
        </div>
        <div class="abi-tips">（微信号：bihu936）</div>
        <div id="copy-btn" @click="copyWx" data-clipboard-text="bihu936">点击复制微信号</div>
      </div>
    </div>
    <div v-if="vip===undefined" class="open-vip align direction">
      <img src="../static/images/open-vip.png" alt="vip" />
      <div class="open-vip-title">壁虎看看年费会员专享功能</div>
      <router-link :to="`/dredgeVip?unSelect=0,2&road=${encodeURIComponent(thisLocation().href)}`" class="open-vip-button">去开通</router-link>
      <div class="open-vip-tips first-line">开通后即可获得达人授权联系方式及部分达人商务对接服务，</div>
      <div class="open-vip-tips">并可查看壁虎看看平台主播、品牌、店铺等带货数据详情</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    links: Array,
    vip: Object
  },
  methods: {
    copyWx() {
      const clipboard = new ClipboardJS('#copy-btn');
      clipboard.on('success', function (e) {
        e.clearSelection();
      });
      this.$dialog.alert({
        message: '复制成功'
      })
    },
    thisLocation() {
      return location
    }
  },
}
</script>

<style lang="less" scoped>
.anchor-contact {
  width: 6rem;
  height: 4.7rem;
  border-radius: 0.16rem;
  background: #fff;
  height: 100%;
  .vip-links {
    .contact-data {
      flex: 1;
      .item-contact {
        margin-top: 0.29rem;
        .contact-name {
          color: #a1aebf;
          font-size: 0.28rem;
          margin-right: 0.1em;
          width: 0.56rem;
        }
        .contact-value {
          width: 1.88rem;
          color: #4a4a4a;
          font-weight: 400;
          font-size: 0.28rem;
        }
      }
    }
    .contact-tips {
      width: 100%;
      height: 0.8rem;
      border-top: 0.02rem solid #e8e6e6;
      color: #a1aebf;
      text-align: center;
      line-height: 0.8rem;
      font-size: 0.2rem;
    }
  }
  .none-links {
    width: 4.6rem;
    margin: 0 auto;
    .none-links-tips {
      margin-top: 0.2rem;
      color: #4a4a4a;
      font-size: 0.28rem;
      line-height: 0.36rem;
    }
    .none-links-tips:nth-child(1) {
      margin-top: 0.4rem;
    }
    .abi {
      border: 0.02rem solid #cad3df;
      width: 1.54rem;
      height: 1.54rem;
      margin-top: 0.26rem;
      img {
        width: 1.5rem;
        height: 1.5rem;
      }
    }
    .abi-tips {
      color: #a1aebf;
      font-size: 0.2rem;
      margin-top: 0.06rem;
    }
    #copy-btn {
      margin-top: 0.5rem;
      color: #2a89f4;
    }
  }
  .open-vip {
    img {
      width: 2rem;
      height: 0.6rem;
      margin-top: 0.6rem;
    }
    .open-vip-title {
      color: #4a4a4a;
      font-size: 0.28rem;
      margin-top: 0.4rem;
    }
    .open-vip-button {
      width: 3rem;
      height: 1rem;
      background: linear-gradient(
        180deg,
        rgba(255, 201, 0, 1) 0%,
        rgba(255, 153, 0, 1) 100%
      );
      border-radius: 0.08rem;
      text-align: center;
      line-height: 1rem;
      color: #fff;
      font-size: 0.36rem;
      margin-top: 0.4rem;
    }
    .open-vip-tips {
      color: #a1aebf;
      font-size: 0.24rem;
      line-height: 0.33rem;
    }
    .first-line {
      margin-top: 0.3rem;
    }
  }
}
</style>